import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const campaignAPI = axios.create({
  baseURL: `${API_BASE_URL}/campaign`,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: { 'Content-Type': 'application/json' },
});

const errorMessage = (error, fallback) =>
  error.response?.data?.message || fallback;

export const campaignService = {
  // Da de baja de los emails de marketing al dueño del token. Respuesta: { ok, email }
  unsubscribe: async (token) => {
    try {
      const response = await campaignAPI.post('/unsubscribe', { token });
      return response.data;
    } catch (error) {
      throw new Error(errorMessage(error, 'No pudimos procesar la baja.'));
    }
  },

  // Deshace la baja (el cliente clickeó por error). Respuesta: { ok, email }
  resubscribe: async (token) => {
    try {
      const response = await campaignAPI.post('/resubscribe', { token });
      return response.data;
    } catch (error) {
      throw new Error(errorMessage(error, 'No pudimos reactivar tu suscripción.'));
    }
  },
};

export default campaignService;
